import { AutocompleteSuggestionPart } from '@dynatrace-sdk/client-query';

import { DocumentationLink } from './DocumentationLink.js';
import { suggestionPartSectionInfoCSS } from './SuggestionPart.sty.js';
import { CodeSnippet } from '../../../content/code-snippet/CodeSnippet.js';
import { Flex } from '../../../layouts/flex/Flex.js';
import { globalSprinkles } from '../../../styles/safe-sprinkles.js';
import { Text } from '../../../typography/text/Text.js';

type Props = {
  suggestionPart: AutocompleteSuggestionPart;
};

export const SuggestionPart = (props: Props) => {
  const { suggestionPart } = props;

  return (
    <Flex flexDirection="column" gap={0}>
      <Text textStyle="base" className={suggestionPartSectionInfoCSS}>
        {suggestionPart.info}{' '}
        <DocumentationLink suggestionPart={suggestionPart} />
      </Text>

      {suggestionPart.synopsis && (
        <CodeSnippet
          language="dql"
          showLineNumbers={false}
          showCopyAction={false}
          lineBreaks
          className={globalSprinkles({ marginTop: 4 })}
        >
          {suggestionPart.synopsis}
        </CodeSnippet>
      )}
    </Flex>
  );
};
